import {NgModule} from '@angular/core';
import {StatisticsComponent} from './statistics.component';
import {StatisticsTabComponent} from './statistics-tab/statistics-tab.component';
import {StatisticsGraphComponent} from './statistics-graph/statistics-graph.component';
import {ComponentsModule} from '../../components/components.module';
import {NgApexchartsModule} from 'ng-apexcharts';

import {FormsModule} from '@angular/forms';
import {SelectButtonModule} from 'primeng/selectbutton';
import {MultiSelectModule} from 'primeng/multiselect';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {TableModule} from 'primeng/table';
import {ToggleButtonModule} from 'primeng/togglebutton';
import {DatePickerModule} from 'primeng/datepicker';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import { StatisticsGraph2Component } from './statistics-graph2/statistics-graph2.component';
import { StatisticsConfigurableGraphComponent } from './statistics-configurable-graph/statistics-configurable-graph.component';
import { ParameterComponent } from './statistics-configurable-graph/parameter/parameter.component';
import {DropdownModule} from 'primeng/dropdown';


const cmp = [StatisticsComponent, StatisticsTabComponent, StatisticsGraphComponent];

@NgModule({
    declarations: [
        ...cmp,
        StatisticsGraph2Component,
        StatisticsConfigurableGraphComponent,
        ParameterComponent,
    ],
    exports: [
        ...cmp
    ],
    imports: [
        ComponentsModule,
        NgApexchartsModule,
        SelectButtonModule,
        MultiSelectModule,
        TieredMenuModule,
        TableModule,
        ToggleButtonModule,
        DatePickerModule,
        ProgressSpinnerModule,
        FormsModule,
        TranslateModule,
        CommonModule,
        DropdownModule
    ]
})
export class StatisticsModule { }
